import { render, staticRenderFns } from "./DomesticPayments.vue?vue&type=template&id=515190a7"
import script from "./DomesticPayments.vue?vue&type=script&lang=js"
export * from "./DomesticPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports